var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimplePdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 38.667,
    viewBox: "0 0 29 38.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(-207.298 -511.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file",
    "data-name": "Icon awesome-file",
    d: "M16.917,10.271V0H1.813A1.808,1.808,0,0,0,0,1.813V36.854a1.808,1.808,0,0,0,1.813,1.813H27.188A1.808,1.808,0,0,0,29,36.854V12.083H18.729A1.818,1.818,0,0,1,16.917,10.271ZM29,9.206v.461H19.333V0h.461a1.811,1.811,0,0,1,1.284.529l7.393,7.4A1.807,1.807,0,0,1,29,9.206Z",
    transform: "translate(207.298 511.044)",
    fill: "#ce1414"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-adobeacrobatreader",
    "data-name": "Icon simple-adobeacrobatreader",
    d: "M20.355,13.265c-.612-.656-1.867-1.032-3.643-1.032a17.75,17.75,0,0,0-3.243.319,17.478,17.478,0,0,1-1.99-2.346,20.215,20.215,0,0,1-1.225-1.975,18.434,18.434,0,0,0,1.04-5.262c0-1.442-.52-2.947-2.018-2.947a1.408,1.408,0,0,0-1.164.69c-.675,1.214-.371,3.875.791,6.5-.434,1.311-.893,2.564-1.466,3.972-.5,1.187-1.073,2.41-1.659,3.533C2.41,16.088.231,17.683.026,18.934a1.389,1.389,0,0,0,.394,1.251,1.933,1.933,0,0,0,1.277.47c2.234,0,4.589-3.692,5.785-5.917.919-.311,1.837-.593,2.754-.875,1.007-.279,2.018-.5,2.937-.66a8.255,8.255,0,0,0,5.484,2.5c1.287,0,1.746-.532,1.9-.968a1.492,1.492,0,0,0-.217-1.5l.017.035Zm-1.195.909a1.1,1.1,0,0,1-1.2.781,3.088,3.088,0,0,1-.52-.062,8,8,0,0,1-3.367-1.817,15.285,15.285,0,0,1,2.57-.216,6.874,6.874,0,0,1,1.561.124c.423.091,1.1.375.945,1.19h.017ZM12.672,12.7c-.794.164-1.651.357-2.539.6-.7.192-1.437.409-2.174.664.4-.778.737-1.53,1.042-2.245.369-.88.673-1.786.979-2.627.3.526.638,1.061.975,1.535a23.787,23.787,0,0,0,1.708,2.087V12.7ZM8.661,1.071A.67.67,0,0,1,9.245.694c.643,0,.765.749.765,1.346a16.75,16.75,0,0,1-.828,4.284c-.916-2.432-.979-4.468-.52-5.253ZM5.295,15.645C3.734,18.27,2.235,19.9,1.316,19.9a.748.748,0,0,1-.457-.158.672.672,0,0,1-.214-.656c.184-.94,1.929-2.254,4.651-3.442Z",
    transform: "translate(211.297 521.845)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplePdf);
export default __webpack_public_path__ + "static/media/simple-pdf.1db5da7df5ac8b346860e22fa4663456.svg";
export { ForwardRef as ReactComponent };